/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { parentPaymentControllerSearch } from '../fn/parent-payment/parent-payment-controller-search';
import { ParentPaymentControllerSearch$Params } from '../fn/parent-payment/parent-payment-controller-search';

@Injectable({ providedIn: 'root' })
export class ParentPaymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `parentPaymentControllerSearch()` */
  static readonly ParentPaymentControllerSearchPath = '/api/parent-payment';

  /**
   * 결제 목록 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parentPaymentControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentPaymentControllerSearch$Response(params: ParentPaymentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return parentPaymentControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 결제 목록 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `parentPaymentControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parentPaymentControllerSearch(params: ParentPaymentControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.parentPaymentControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

}
